import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';
import Dialog from "@material-ui/core/Dialog";

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox
} from '@material-ui/core';


import { useFormContext, Controller } from "react-hook-form";
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import api from '../../../store/api';
import { getDataFromStorage } from '../../../common/sessionStorageHelpers';
import { persistName } from '../../Schedule/helpers/transferScheduleHelpers';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useState } from 'react';

import IndexedDb from '../IndexedDb';
import { $CombinedState } from 'redux';

import { format, getDate } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import GooglePlaceAutoComplete from '../GooglePlaceAutoComplete';

import { anchorCustomPositionType } from 'react-xarrows';
import { method } from "./Observations";
import { RootState } from "../../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { isSMAUser } from '../../dashboard/helpers/dashboardHelpers';
import { NullLogger } from '@microsoft/signalr';
import { isDate } from 'lodash';
import { json } from 'stream/consumers';
import Background from './Background';
import Observationdata from '../../../../src/data/Observationdata.json';
import moment from 'moment'
import { pcrstate } from '../../../store/modules/PcrSlice';
export interface PcrWidgetProps extends IAppPropsWithRoute {
    getparentindexdbvalues: any
};
export interface SelectItem extends React.Props<any> {
    text: string | undefined;
    value: string | undefined;
    selected: boolean;
    deleted: boolean;
}

const SubFormWidget: React.FC<PcrWidgetProps> = ({ getparentindexdbvalues }) => {
    const classes = useStyles();
    const history = useHistory();
    const [dateDialog, setDateDialog] = React.useState(false);
    const [dob, setDob] = React.useState(false);
    const [Indexdb, setIndexdb] = useState("");
    const pcr = useSelector(pcrstate)
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    const dobs = watch("Date_of_birth");
    const lang_at_home = watch("lang_at_home");
    const [customersDefaultValue, setCustomerDefaultValue] = useState('');
    const [customerDatas, setCustomerDatas] = useState<SelectItem[]>([]);
    const [CustomerIdb, setCustomerIdb] = useState<String>("");
    const [CustSurnameIdb, setCustSurnameIdb] = useState<String>("");
    const [CustGivenNameIdb, setCustGivenNameIdb] = useState<String>("");
    const [DOBIdb, setDOBIdb] = useState(new Date());
    const [EstimatedIdb, setEstimatedIdb] = useState<String>("");
    const [GenderIdb, setGenderIdb] = useState<String>("");
    const [mrnIdb, setmrnIdb] = useState<String>("");
    const [LanguageIdb, setLanguageIdb] = useState<String>("");
    const [TranslatorIdb, setTranslatorIdb] = useState<boolean>();
    const [AboriginalIdb, setAboriginalIdb] = useState<String>("");
    const [patientAddressIdb, setpatientAddressIdb] = useState<String>("");
    const [PatientMobilePhoneIdb, setPatientMobilePhoneIdb] = useState<String>("");
    const [SurveyIdb, setsurveyIdb] = useState<String>("");
    const [KinMobilePhoneIdb, setKinMobilePhoneIdb] = useState<String>("");
    const [KinNameIdb, setKinNameIdb] = useState<String>("");
    const [PatientTranBookNoIdb, setPatientTranBookNoIdb] = useState<String>("");
    const [ReasonForTransport, setReasonForTransport] = useState<String>("");
    const [date, setDate] = useState("");
    const [value, onChange] = useState(new Date());
    const { authStore } = useSelector((state: RootState) => state);
    const SMAUser = useState(authStore.data?.IsSMAUser);
    const location = useState(authStore.data?.location);
    let CustSurName: any = "";
    let Trans: boolean = false;
    React.useEffect(() => {
        loadData();
        let db: any = null;
        let patvalue: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        handleindexdbsaveuseremail();
        patvalue = localStorage.getItem("Patientidentification");
        let customer = localStorage.getItem("Customerid");
        if (patvalue != null && patvalue != "") {
            var res = JSON.parse(patvalue);
            setValue("Givenname", res.firstName);
            setValue("surname", res.lastName);
            var dates = new Date(res.birthday);
            setSelectedDate(dates);
            setValue("Gender", res.gender);
            setValue("patientAddress", res.patientAddress);
            setValue("Customer", res.destinationCustomerId);
            setValue("PatientTransportBookingNumber", res.bookingNumber);
            setPatientTranBookNoIdb(res.bookingNumber);
            setValue("Customer", res.customerID);
            setValue("ReasonForTransport", res.reasonForTransport);
            setValue("pcr_type", 2);
            setValue("aboriginal_or_torres", GetIndegennousValue(res.aboriginal));
            setValue("MRN", res.mrn);
            /* Booking = 1 => Yes - Indigenous (Aboriginal), 2 => Not Disclosed (Unspecified)*/
            setValue("aboriginal_or_torres", GetIndegennousValue(res.isIdentifiedAsIndegennous) ?? "");
            setAboriginalIdb(GetIndegennousValue(res.isIdentifiedAsIndegennous) ?? "")
            setReasonForTransport(res.reasonForTransport);
            handleindexdbsaveload(res);
            localStorage.setItem("Patientidentification", "");
        }
        if (customer) {
            loadCustomer(customer, db);
        }
        getindexdbvalues();
        localStorage.removeItem("Dob");
    }, [])

    const GetIndegennousValue = (value:number) => {

        switch (value) {
            case 0:
                return "1"
            case 1:
                return "2"
            case 2 :
                return "5"
            case 3:
                return "3"
            case 4:
                return "4"
            default:
                return "1"
        }
    }

    React.useEffect(() => {
        getindexdbvalues();
    }, [pcrType])
    
    const handleindexdbsaveuseremail = async (): Promise<void> => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.putValue("Patientidentification", { column: authStore.data?.email, Patid: 0 }, "Useremail");
        }
    }
    const [selectedDate, setSelectedDate] = useState<Date>();
    const handleDateChange = (date: any) => {
        setSelectedDate(date);
        setValue("DOB", date);
    };
    React.useEffect(() => {
        if (dob) {
            localStorage.setItem("Dob", "true");
        }
    }, [dob])

    const loadData = async (): Promise<void> => {
        try {
            await getCustomersData(false);
        }
        catch (error) {
            console.error(error);
        }
    }
    const loadCustomer = async (id: any, db: any): Promise<void> => {
        try {
            if (db != null || db != "") {
                const indexedDb = new IndexedDb(db);
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                await indexedDb.deleteValue('Patientidentification', "Customer");
                await indexedDb.putValue('Patientidentification', { column: id, Patid: 0 }, "Customer");
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    const handleindexdbsaveload = async (value: any): Promise<void> => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('Patientidentification', "CustGivenName");
            await indexedDb.putValue('Patientidentification', { column: 2, Patid: 0 }, "PCRType");
            await indexedDb.putValue('Patientidentification', { column: value.firstName, Patid: 0 }, "CustGivenName");
            await indexedDb.putValue('Patientidentification', { column: value.lastName, Patid: 0 }, "CustSurName");
            await indexedDb.putValue('Patientidentification', { column: new Date(value.birthday), Patid: 0 }, "DOB");
            setValue("DOB", new Date(value.birthday))
            await indexedDb.putValue('Patientidentification', { column: value.gender, Patid: 0 }, "Gender");
            await indexedDb.putValue('Patientidentification', { column: value.patientAddress, Patid: 0 }, "patientAddress");
            await indexedDb.putValue('Patientidentification', { column: value.destinationCustomerId, Patid: 0 }, "Customer");
            await indexedDb.putValue('Patientidentification', { column: value.bookingNumber, Patid: 0 }, "PatientTranBookNo");
            await indexedDb.putValue('Patientidentification', { column: value.customerID, Patid: 0 }, "Customer");
            await indexedDb.putValue('Patientidentification', { column: value.reasonForTransport, Patid: 0 }, "ReasonForTransport");
            await indexedDb.putValue('Patientidentification', { column: value.transferId, Patid: 0 }, "TransferId");
            await indexedDb.putValue('Patientidentification', { column: value.mrn, Patid: 0 }, "mrn");
            await indexedDb.deleteValue('Patientidentification', "aboriginal");
            await indexedDb.putValue('Patientidentification', { column: GetIndegennousValue(value.isIdentifiedAsIndegennous) ?? "", Patid: 0 }, "aboriginal");
            await indexedDb.deleteValue('Observation', "PatientWeight");
            await indexedDb.putValue('Observation', { column: value.weight, Patid: 0 }, "PatientWeight");
            await indexedDb.deleteValue('Situation', "acuity");
            await indexedDb.putValue('Situation', { column: value?.classification, Patid: 0 }, "acuity");
            await indexedDb.deleteValue('Situation', "isNSWLocation");
            await indexedDb.putValue('Situation', { column: value.isNSWLocation, Patid: 0 }, "isNSWLocation");

            if(value.originCustLocationGooglePlaceId != null && value.originCustLocationGooglePlaceId != "") {
                    let fullAddress = '';
                    fullAddress += value.originCustLocationGeoName ? value.originCustLocationGeoName + ', ' : '';
                    fullAddress += value?.originCustLocationStreetAddress ? value?.originCustLocationStreetAddress + ', ' : '';
                    fullAddress += value?.originCustLocationSuburb ? value?.originCustLocationSuburb + ', ' : '';
                    fullAddress += value?.originCustLocationState ? value?.originCustLocationState + ', ' : '';
                    fullAddress += value?.originCustLocationPostcode ? value?.originCustLocationPostcode : '';
                await indexedDb.deleteValue('Situation', "pickuplocation");
                await indexedDb.putValue('Situation', { column: fullAddress, Patid: 0 }, "pickuplocation");
                await indexedDb.deleteValue('Situation', "pickuplocationgoogleplaceid");
                await indexedDb.putValue('Situation', { column: value?.originCustLocationGooglePlaceId, Patid: 0 }, "pickuplocationgoogleplaceid");
            }

            if(value.originGooglePlaceId != null && value.originGooglePlaceId != "") {
                let fullAddress = '';
                fullAddress += value.originName ? value.originName + ', ' : '';
                fullAddress += value?.originStreetAddress ? value?.originStreetAddress + ', ' : '';
                fullAddress += value?.originSuburb ? value?.originSuburb + ', ' : '';
                fullAddress += value?.originState ? value?.originState + ', ' : '';
                fullAddress += value?.originPostcode ? value?.originPostcode : '';
            await indexedDb.deleteValue('Situation', "pickuplocation");
            await indexedDb.putValue('Situation', { column: fullAddress, Patid: 0 }, "pickuplocation");
            await indexedDb.deleteValue('Situation', "pickuplocationgoogleplaceid");
            await indexedDb.putValue('Situation', { column: value?.originGooglePlaceId, Patid: 0 }, "pickuplocationgoogleplaceid");
        }

            if(value.destCustLocationGooglePlaceId != null && value.destCustLocationGooglePlaceId != "") {
                let fullAddress = '';
                    fullAddress += value.destCustLocationGeoName ? value.destCustLocationGeoName + ', ' : '';
                    fullAddress += value?.destCustLocationStreetAddress ? value?.destCustLocationStreetAddress + ', ' : '';
                    fullAddress += value?.destCustLocationSuburb ? value?.destCustLocationSuburb + ', ' : '';
                    fullAddress += value?.destCustLocationState ? value?.destCustLocationState + ', ' : '';
                    fullAddress += value?.destCustLocationPostcode ? value?.destCustLocationPostcode : '';
                await indexedDb.deleteValue('Handover', "Handoverlocation");
                await indexedDb.putValue('Handover', { column: fullAddress, Patid: 0 }, "Handoverlocation");
                await indexedDb.deleteValue('Handover', "Handoverlocationgoogleplaceid");
                await indexedDb.putValue('Handover', { column: value?.destCustLocationGooglePlaceId, Patid: 0 }, "Handoverlocationgoogleplaceid");
            }

            if(value.destinationGooglePlaceId != null && value.destinationGooglePlaceId != "") {
                let fullAddress = '';
                    fullAddress += value.destinationName ? value.destinationName + ', ' : '';
                    fullAddress += value?.destinationStreetAddress ? value?.destinationStreetAddress + ', ' : '';
                    fullAddress += value?.destinationSuburb ? value?.destinationSuburb + ', ' : '';
                    fullAddress += value?.destinationState ? value?.destinationState + ', ' : '';
                    fullAddress += value?.destinationPostcode ? value?.destinationPostcode : '';
                await indexedDb.deleteValue('Handover', "Handoverlocation");
                await indexedDb.putValue('Handover', { column: fullAddress, Patid: 0 }, "Handoverlocation");
                await indexedDb.deleteValue('Handover', "Handoverlocationgoogleplaceid");
                await indexedDb.putValue('Handover', { column: value?.destinationGooglePlaceId, Patid: 0 }, "Handoverlocationgoogleplaceid");
            }
        }
        getparentindexdbvalues();
    }
    const getCustomersData = async (showDefault: boolean): Promise<void> => {
        try {
            const resdata = await api.getPCRCustomers('');
            if (resdata !== null) {
                localStorage.setItem('customerDatas', JSON.stringify(resdata.data.model));
                const customerDatasLS = localStorage.getItem('customerDatas');
                let res: SelectItem[] = [];
                if (customerDatasLS) {
                    res = JSON.parse(customerDatasLS);
                } else {
                    const apiData = await api.getPCRCustomers('');
                    res = apiData.data.model ?? [];
                    localStorage.setItem('customerDatas', JSON.stringify(apiData.data.model));
                }
                const selectedCustomers = getDataFromStorage(persistName, "selectedCustomers");
                if (selectedCustomers !== null && selectedCustomers !== undefined && selectedCustomers.length === 1) {
                    res = res.map(l => {
                        return {
                            ...l,
                            selected: l.value === selectedCustomers[0]
                        }
                    })
                    setCustomerDefaultValue(selectedCustomers[0]);
                }
                setCustomerDatas(res);
            }
            else {
                const customerDatasLS = localStorage.getItem('customerDatas');
                let res: SelectItem[] = [];
                if (customerDatasLS) {
                    res = JSON.parse(customerDatasLS);
                }
                const selectedCustomers = getDataFromStorage(persistName, "selectedCustomers");
                if (selectedCustomers !== null && selectedCustomers !== undefined && selectedCustomers.length === 1) {
                    res = res.map(l => {
                        return {
                            ...l,
                            selected: l.value === selectedCustomers[0]
                        }
                    })
                    setCustomerDefaultValue(selectedCustomers[0]);
                }
                setCustomerDatas(res);
            }
        }
        catch (error) {
        }
    }

    const handleindexdbsave = async (Key: any, value: any): Promise<void> => {
        var newdate = new Date().toLocaleString();
        let values = getValues();

        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('Patientidentification', Key);
            await indexedDb.putValue('Patientidentification', { column: value, Patid: 0 }, Key);
        }


    }
    const getindexdbvalues = async (): Promise<void> => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        if (db != null && db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('Patientidentification');
            for (let i = 0; i < val.length; i++) {
                if (val[i].Key == "CustGivenName") {
                    setValue("Givenname", val[i].value.column);
                }
                if (val[i].Key == "CustSurName") {
                    setValue("surname", val[i].value.column);
                }
                if (val[i].Key == "ReasonForTransport") {
                    setValue("ReasonForTransport", val[i].value.column);
                    setReasonForTransport(val[i].value.column);
                }
                if (val[i].Key == "Customer") {
                    setValue("Customer", val[i].value.column);
                }
                if (val[i].Key == "DOB") {
                    var dates = (val[i].value.column);
                    setSelectedDate(dates != null ? dates : null);
                    setValue("DOB", dates);
                }
                if (val[i].Key == "Estimated") {
                    setValue("Estimated", val[i].value.column);
                }
                if (val[i].Key == "Gender") {

                    setValue("Gender", val[i].value.column);
                }

                if (val[i].Key == "mrn") {

                    setValue("MRN", val[i].value.column);
                }
                if (val[i].Key == "Language") {

                    setValue("lang_at_home", val[i].value.column);
                }
                if (val[i].Key == "aboriginal") {

                    setValue("aboriginal_or_torres", val[i].value.column);
                }
                if (val[i].Key == "patientAddress") {

                    setValue("patientAddress", val[i].value.column);
                }
                if (val[i].Key == "PatientMobilePhone") {

                    setValue("PatientMobilePhone", val[i].value.column);
                }
                if (val[i].Key == "survey") {

                    setValue("patient_not_survey", val[i].value.column);
                }
                if (val[i].Key == "KinMobilePhone") {

                    setValue("KinMobilePhone", val[i].value.column);
                }

                if (val[i].Key == "KinName") {

                    setValue("KinName", val[i].value.column);
                }
                if (val[i].Key == "PatientTranBookNo") {

                    setPatientTranBookNoIdb(val[i].value.column);
                    setValue("PatientTransportBookingNumber", val[i].value.column);
                }
                if (val[i].Key == "Translator") {
                    setTranslatorIdb(val[i].value.column)
                    setValue("translator_req", val[i].value.column);
                }
            }
        }
    }
    const validatedob = async (value: any) => {
        if (selectedDate !== null && selectedDate !== undefined) {
            let db = localStorage.getItem("PatientDB");
            if (db != null && db != "") {
                const indexedDb = new IndexedDb(db);
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                let Patientidentification = await indexedDb.getAllValue('Patientidentification');
                for (let i = 0; i < Patientidentification.length; i++) {
                    if (Patientidentification[i].Key == "DOB") {
                        var dates = (Patientidentification[i].value.column);
                        if (dates === null) {
                            return 'Dob is required';
                        }
                    }
                }
            }
            return true;
        }
        else {
            return 'Dob is required';
        }

    };
    const validateBooking = async () => {
        var s = PatientTranBookNoIdb;
        if(s == "" || s == undefined || s == null)
        {
            if(pcr.ValidateAllFields) {
                return 'Patient Transport Booking Number is required';
            }
        }
      };
    return (
        <div>
            <div className={classes.pcrAddTabHeading}>
                <div>
                    Patient Identification
                </div>
            </div>
            <Grid container className={classes.formContainer} spacing={3}>
                {SMAUser[0] ?
                    <Grid item xs={12} sm={12}>
                        <div className={classes.formControlLabel}>
                            <Icons.RequiredIcon />CUSTOMER
                        </div>
                        <Controller
                            control={control}
                            defaultValue={CustomerIdb}
                            render={({ onChange, onBlur, value, name }) => (
                                <React.Fragment>
                                    <Select
                                        onChange={e => {
                                            onChange(e);
                                            handleindexdbsave('Customer', e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            handleindexdbsave('Customer', e.target.value);
                                        }}
                                        defaultValue={CustomerIdb}
                                        value={value}
                                        name={name}
                                        className={classes.selectField}
                                        IconComponent={KeyboardArrowDownIcon}
                                        fullWidth={true}
                                        required
                                        error={errors.Customer}
                                        variant="outlined">
                                        <MenuItem key="None" defaultValue='0' value='0'>Choose</MenuItem >
                                        {
                                            customerDatas.filter(item => item.deleted != true).map(item => <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem >)
                                        }

                                    </Select>
                                    <FormHelperText className={classes.helperText}>{errors.Customer ? errors.Customer.message : ''}</FormHelperText>
                                </React.Fragment>
                            )}
                            name="Customer"
                            rules={{
                                validate: (value) => {
                                    if (value === null || value === '' || value === '0') {
                                        return "Customer is required"
                                    }
                                }
                            }}
                        />

                    </Grid> : null}
                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />SURNAME
                    </div>
                    <Controller
                        control={control}
                        render={({ onChange, onBlur, value, name }) => (
                            <React.Fragment>
                                <TextField
                                    onChange={e => {
                                        onChange(e);
                                    }}
                                    onBlur={(e) => {
                                        handleindexdbsave('CustSurName', e.target.value);
                                    }}
                                    value={value}
                                    name={name}
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    inputProps={{ maxLength: 100, minLength: 0, autocomplete: 'disabled' }}
                                    required
                                    variant="outlined">

                                </TextField>
                                <FormHelperText style={{ color: "red" }}>{errors.surname ? errors.surname.message : ""}</FormHelperText>
                            </React.Fragment>
                        )}
                        name="surname"
                        rules={{
                            required: "Surname is required",
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />GIVEN NAME
                    </div>
                    <Controller
                        control={control}
                        defaultValue={CustGivenNameIdb}
                        render={({ onChange, onBlur, value, name }) => (
                            <React.Fragment>
                                <TextField
                                    onChange={e => {
                                        onChange(e)
                                    }}
                                    onBlur={(e) => {
                                        handleindexdbsave('CustGivenName', e.target.value);
                                    }}

                                    value={value}
                                    defaultValue={CustGivenNameIdb}
                                    name={name}
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    inputProps={{ maxLength: 100, minLength: 0, autocomplete: 'disabled' }}
                                    required
                                    variant="outlined"
                                >

                                </TextField>
                                <FormHelperText style={{ color: "red" }}>{errors.Givenname ? errors.Givenname.message : ""}</FormHelperText>
                            </React.Fragment>
                        )}
                        name="Givenname"
                        rules={{
                            required: "Given name is required",
                        }}

                    />
                </Grid>

                <Grid item xs={6} sm={3}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />DOB
                    </div>
                    <Controller
                        control={control}
                        name="DOB"
                        defaultValue={selectedDate != null ? selectedDate : null}
                        render={({ onChange, onBlur, value, name }) => (
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    inputVariant="outlined"
                                    value={selectedDate || null}
                                    format="dd/MM/yyyy"
                                    autoOk={true}
                                    cancelLabel={false}
                                    okLabel={false}
                                    onChange={(e: any) => {
                                        if (e !== null) {
                                            let timestamp = Date.parse(e.toString());
                                            if (!isNaN(timestamp)) {
                                                handleDateChange(timestamp);
                                                handleindexdbsave('DOB', timestamp);
                                                setDob(true)
                                            }
                                        }
                                        else {
                                            handleindexdbsave('DOB', null);
                                        }

                                    }}
                                    defaultValue={selectedDate}
                                    maxDate={new Date()}
                                    placeholder="DD/MM/YYYY"
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    onFocusCapture={(e) => {
                                        if (e !== null) {
                                            let timestamp = Date.parse(e.toString());
                                            if (!isNaN(timestamp)) {
                                                handleindexdbsave('DOB', timestamp);
                                            }
                                        }
                                        else {
                                            handleindexdbsave('DOB', null);
                                        }

                                    }
                                    }
                                    onBlur={(e) => {
                                        if (e !== null) {
                                            let timestamp = Date.parse(e.toString());
                                            if (!isNaN(timestamp)) {
                                                setValue("DOB", timestamp)
                                                handleindexdbsave('DOB', timestamp);
                                            }
                                        }
                                        else {
                                            setValue("DOB", null)
                                            handleindexdbsave('DOB', null);
                                        }
                                    }}
                                    keyboardIcon={<Icons.DatePickerIcon />}


                                />
                                <FormHelperText style={{ color: "red" }}>{errors.DOB ? errors.DOB.message : ""}</FormHelperText>
                            </MuiPickersUtilsProvider>

                        )}
                        rules={{
                            validate: validatedob,
                        }}
                    />
                </Grid>
                
                <Grid item xs={6} sm={3}>
                    <Controller
                        control={control}
                        defaultValue={false}
                        render={({ onChange, onBlur, value, name }) => (
                            <>
                                <FormControl fullWidth error={errors.dob_estimated}>
                                    <FormControlLabel
                                        control={<Checkbox className={classes.checkboxInput} />}
                                        label='Estimated'
                                        checked={value}
                                        onChange={(e: React.ChangeEvent<any>) =>
                                            onChange(e.target.checked,
                                                handleindexdbsave('Estimated', e.target.checked),
                                                setEstimatedIdb(e.target.checked))
                                        }
                                        style={{ marginTop: 20 }}
                                    />
                                    <FormHelperText>{errors.dob_estimated ? errors.dob_estimated.message : ""}</FormHelperText>
                                </FormControl>
                            </>
                        )}
                        name="Estimated"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />GENDER
                    </div>
                    <Controller
                        control={control}
                        defaultValue=""
                        render={({ onChange, onBlur, value, name }) => (
                            <>
                                <FormControl fullWidth error={errors.gender}>
                                    <Select
                                        name={name}
                                        value={value}
                                        onChange={(e: any) => { onChange(e); handleindexdbsave('Gender', e.target.value); }}
                                        className={classes.selectField}
                                        IconComponent={KeyboardArrowDownIcon}
                                        displayEmpty
                                        fullWidth={true}
                                        variant="outlined"
                                        onBlur={(e) => {
                                            handleindexdbsave('Gender', e.target.value);
                                            setGenderIdb(e.target.value);
                                        }}
                                    >
                                        <MenuItem key="None" value="">Choose</MenuItem >
                                        <MenuItem key={1} value={"1"}>{"Male"}</MenuItem >
                                        <MenuItem key={2} value={"2"}>{"Female"}</MenuItem >
                                        <MenuItem key={3} value={"3"}>{"Other"}</MenuItem >
                                        <MenuItem key={3} value={"4"}>{"Unspecified"}</MenuItem >
                                        {/* <MenuItem key={3} value={"3"}>{"Not Disclosed"}</MenuItem > */}
                                    </Select>
                                    <FormHelperText style={{ color: "red" }}>{errors.Gender ? errors.Gender.message : ""}</FormHelperText>
                                </FormControl>
                            </>
                        )}
                        name="Gender"
                        rules={{
                            required: "Gender is required",
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                        {/* <Icons.RequiredIcon /> MRN */}
                        MRN
                    </div>
                    <Controller
                        control={control}
                        render={({ onChange, onBlur, value, name }) => (
                            <React.Fragment>
                                <TextField
                                    onChange={e => {
                                        onChange(e)
                                    }}
                                    onBlur={(e) => {
                                        handleindexdbsave('mrn', e.target.value);
                                        setmrnIdb(e.target.value);
                                    }}
                                    value={value}
                                    name={name}
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    inputProps={{ maxLength: 100, minLength: 0, autocomplete: 'disabled' }}
                                    variant="outlined">

                                </TextField>
                            </React.Fragment>
                        )}

                        name="MRN"

                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                        LANGUAGE SPOKEN AT HOME
                    </div>
                    <Controller
                        control={control}
                        name="lang_at_home"
                        defaultValue=""
                        render={({ onChange, onBlur, value, name }) => (
                            <>
                                <FormControl fullWidth error={errors.lang_at_home}>
                                    <Select
                                        name={name}
                                        value={value}
                                        onChange={(e: any) => { onChange(e); handleindexdbsave('Language', e.target.value); }}
                                        className={classes.selectField}
                                        IconComponent={KeyboardArrowDownIcon}
                                        displayEmpty
                                        fullWidth={true}
                                        variant="outlined"
                                        onBlur={(e) => {
                                            handleindexdbsave('Language', e.target.value);
                                            setLanguageIdb(e.target.value);
                                        }}
                                    >
                                        <MenuItem key="None" value="">Choose</MenuItem >
                                        {/* <MenuItem key={1} value={"1"}>{"English"}</MenuItem > */}
                                        {/*<MenuItem key={2} value={"2"}>{"Tamil"}</MenuItem >*/}
                                        <MenuItem key={"1"} value={"1"}>{"Afrikanns"}</MenuItem >
                                        <MenuItem key={"2"} value={"2"}>{"Albanian"}</MenuItem >
                                        <MenuItem key={"3"} value={"3"}>{"Arabic"}</MenuItem >
                                        <MenuItem key={"4"} value={"4"}>{"Armenian"}</MenuItem >
                                        <MenuItem key={"5"} value={"5"}>{"Basque"}</MenuItem >
                                        <MenuItem key={"6"} value={"6"}>{"Bengali"}</MenuItem >
                                        <MenuItem key={"7"} value={"7"}>{"Bulgarian"}</MenuItem >
                                        <MenuItem key={"8"} value={"8"}>{"Catalan"}</MenuItem >
                                        <MenuItem key={"9"} value={"9"}>{"Cambodian"}</MenuItem >
                                        <MenuItem key={"10"} value={"10"}>{"Chinese (Mandarin)"}</MenuItem >
                                        <MenuItem key={"11"} value={"11"}>{"Croation"}</MenuItem >
                                        <MenuItem key={"12"} value={"12"}>{"Czech"}</MenuItem >
                                        <MenuItem key={"13"} value={"13"}>{"Danish"}</MenuItem >
                                        <MenuItem key={"14"} value={"14"}>{"Dutch"}</MenuItem >
                                        <MenuItem key={"15"} value={"15"}>{"English"}</MenuItem >
                                        <MenuItem key={"16"} value={"16"}>{"Estonian"}</MenuItem >
                                        <MenuItem key={"17"} value={"17"}>{"Fiji"}</MenuItem >
                                        <MenuItem key={"18"} value={"18"}>{"Finnish"}</MenuItem >
                                        <MenuItem key={"19"} value={"19"}>{"French"}</MenuItem >
                                        <MenuItem key={"20"} value={"20"}>{"Georgian"}</MenuItem >
                                        <MenuItem key={"21"} value={"21"}>{"German"}</MenuItem >
                                        <MenuItem key={"22"} value={"22"}>{"Greek"}</MenuItem >
                                        <MenuItem key={"23"} value={"23"}>{"Gujarati"}</MenuItem >
                                        <MenuItem key={"24"} value={"24"}>{"Hebrew"}</MenuItem >
                                        <MenuItem key={"25"} value={"25"}>{"Hindi"}</MenuItem >
                                        <MenuItem key={"26"} value={"26"}>{"Hungarian"}</MenuItem >
                                        <MenuItem key={"27"} value={"27"}>{"Icelandic"}</MenuItem >
                                        <MenuItem key={"28"} value={"28"}>{"Indonesian"}</MenuItem >
                                        <MenuItem key={"29"} value={"29"}>{"Irish"}</MenuItem >
                                        <MenuItem key={"30"} value={"30"}>{"Italian"}</MenuItem >
                                        <MenuItem key={"31"} value={"31"}>{"Japanese"}</MenuItem >
                                        <MenuItem key={"32"} value={"32"}>{"Javanese"}</MenuItem >
                                        <MenuItem key={"33"} value={"33"}>{"Korean"}</MenuItem >
                                        <MenuItem key={"34"} value={"34"}>{"Latin"}</MenuItem >
                                        <MenuItem key={"35"} value={"35"}>{"Latvian"}</MenuItem >
                                        <MenuItem key={"36"} value={"36"}>{"Lithuanian"}</MenuItem >
                                        <MenuItem key={"37"} value={"37"}>{"Macedonian"}</MenuItem >
                                        <MenuItem key={"38"} value={"38"}>{"Malay"}</MenuItem >
                                        <MenuItem key={"39"} value={"39"}>{"Malayalam"}</MenuItem >
                                        <MenuItem key={"40"} value={"40"}>{"Maltese"}</MenuItem >
                                        <MenuItem key={"41"} value={"41"}>{"Maori"}</MenuItem >
                                        <MenuItem key={"42"} value={"42"}>{"Marathi"}</MenuItem >
                                        <MenuItem key={"43"} value={"43"}>{"Mongolian"}</MenuItem >
                                        <MenuItem key={"44"} value={"44"}>{"Nepali"}</MenuItem >
                                        <MenuItem key={"45"} value={"45"}>{"Norwegian"}</MenuItem >
                                        <MenuItem key={"46"} value={"46"}>{"Persian"}</MenuItem >
                                        <MenuItem key={"47"} value={"47"}>{"Polish"}</MenuItem >
                                        <MenuItem key={"48"} value={"48"}>{"Portuguese"}</MenuItem >
                                        <MenuItem key={"49"} value={"49"}>{"Punjabi"}</MenuItem >
                                        <MenuItem key={"50"} value={"50"}>{"Quechua"}</MenuItem >
                                        <MenuItem key={"51"} value={"51"}>{"Romanian"}</MenuItem >
                                        <MenuItem key={"52"} value={"52"}>{"Russian"}</MenuItem >
                                        <MenuItem key={"53"} value={"53"}>{"Samoan"}</MenuItem >
                                        <MenuItem key={"54"} value={"54"}>{"Serbian"}</MenuItem >
                                        <MenuItem key={"55"} value={"55"}>{"Slovak"}</MenuItem >
                                        <MenuItem key={"56"} value={"56"}>{"Slovenian"}</MenuItem >
                                        <MenuItem key={"57"} value={"57"}>{"Spanish"}</MenuItem >
                                        <MenuItem key={"58"} value={"58"}>{"Swahili"}</MenuItem >
                                        <MenuItem key={"59"} value={"59"}>{"Swedish "}</MenuItem >
                                        <MenuItem key={"60"} value={"60"}>{"Tamil"}</MenuItem >
                                        <MenuItem key={"61"} value={"61"}>{"Tatar"}</MenuItem >
                                        <MenuItem key={"62"} value={"62"}>{"Telugu"}</MenuItem >
                                        <MenuItem key={"63"} value={"63"}>{"Thai"}</MenuItem >
                                        <MenuItem key={"64"} value={"64"}>{"Tibetan"}</MenuItem >
                                        <MenuItem key={"65"} value={"65"}>{"Tonga"}</MenuItem >
                                        <MenuItem key={"66"} value={"66"}>{"Turkish"}</MenuItem >
                                        <MenuItem key={"67"} value={"67"}>{"Ukranian"}</MenuItem >
                                        <MenuItem key={"68"} value={"68"}>{"Urdu"}</MenuItem >
                                        <MenuItem key={"69"} value={"69"}>{"Uzbek"}</MenuItem >
                                        <MenuItem key={"70"} value={"70"}>{"Vietnamese"}</MenuItem >
                                        <MenuItem key={"71"} value={"71"}>{"Welsh"}</MenuItem >
                                        <MenuItem key={"72"} value={"72"}>{"Xhosa"}</MenuItem >

                                    </Select>
                                    <FormHelperText>{errors.lang_at_home ? errors.lang_at_home.message : ""}</FormHelperText>
                                    {/* <div className={classes.helpText}>
                                        Translation service call 1800 888 888
                                    </div> */}
                                </FormControl>
                            </>
                        )}
                    />

                    {lang_at_home && lang_at_home !== "15" && (<>
                        <Controller
                            control={control}
                            name="translator_req"
                            defaultValue={TranslatorIdb}
                            render={({ onChange, onBlur, value, name }) => (
                                <>
                                    <FormControl fullWidth error={errors.translator_req}>
                                        <FormControlLabel
                                            value={value}
                                            checked={Boolean(TranslatorIdb)}
                                            control={
                                                <Checkbox
                                                    name={name}
                                                    className={classes.checkboxInput}
                                                    style={{ margin: 0 }}
                                                    checked={value}
                                                    onChange={(e: React.ChangeEvent<any>) =>
                                                        onChange(e.target.checked, setTranslatorIdb(e.target.checked), handleindexdbsave('Translator', e.target.checked)
                                                        )}
                                                />
                                            }
                                            label='Translator is required'
                                        />
                                        <FormHelperText>{errors.translator_req ? errors.translator_req.message : ""}</FormHelperText>
                                        {(value) && (<>
                                            <div className={classes.helpText}>
                                                <Icons.HelpIcon /> Please call 131 450 for translation service {TranslatorIdb}
                                            </div>
                                        </>)}

                                    </FormControl>
                                </>
                            )}
                        />
                    </>)}

                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />ABORIGINAL OR TORRES STRAIT ISLANDER?
                    </div>
                    <Controller
                        control={control}
                        name="aboriginal_or_torres"
                        defaultValue={AboriginalIdb}
                        render={({ name, onBlur, onChange, value }) => {
                            return (
                                <>
                                    <FormControl fullWidth error={errors.aboriginal_or_torres}>
                                        <RadioGroup
                                            row
                                            value={value}
                                            onChange={(e: React.ChangeEvent<any>) =>
                                                onChange(e,
                                                    handleindexdbsave('aboriginal', e.target.value),
                                                    setAboriginalIdb(e.target.value))
                                            }
                                            onBlur={(e) => {
                                                handleindexdbsave('aboriginal', value);
                                                setAboriginalIdb(value);
                                            }}
                                        >
                                            <FormControlLabel
                                                value={"1" || ""}
                                                control={<Radio />}
                                                label="Neither"
                                            />
                                            <FormControlLabel
                                                value="2"
                                                control={<Radio />}
                                                label="Aboriginal"
                                            />
                                            <FormControlLabel
                                                value="3"
                                                control={<Radio />}
                                                label="Torres Strait Islander"
                                            />
                                            <FormControlLabel
                                                value="4"
                                                control={<Radio />}
                                                label="Both"
                                            />
                                            <FormControlLabel
                                                value="5"
                                                control={<Radio />}
                                                label="Unspecified"
                                            />
                                        </RadioGroup>
                                        <FormHelperText>{errors.aboriginal_or_torres ? errors.aboriginal_or_torres.message : ""}</FormHelperText>
                                    </FormControl>
                                </>
                            )
                        }}
                        rules={{
                            required: "Aboriginal is required",
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                    <Icons.RequiredIcon /> PATIENT ADDRESS
                        </div>
                     <Controller
                                name='patientAddress'
                                defaultValue=''
                                control={control}
                                render={({ onChange, onBlur, value }) => (
                                    <>
                                    <GooglePlaceAutoComplete
                                        placeholder=''
                                        onInputChange={(value: string) => {
                                            onChange(value);
                                            onBlur();
                                            handleindexdbsave('patientAddress', value);
                                            setpatientAddressIdb(value);
                                        }}                                    
                                        onChange={(value: any) => {
                                            if (value) {
                                              handleindexdbsave('patientAddressgoogleplaceid', value.place_id);
                                            }
                                          }}
                                        value={''}
                                        inputValue={value}
                                        singleLine={true}
                                        hideNoOption={true}
                                        error={errors.patientAddress}
                                        //errorMessage={errors.patientAddress ? errors.patientAddress.message : ''}                                     
                                    />  
                                    {errors.patientAddress && (
                                        <FormHelperText style={{color:"red"}}>{errors.patientAddress ? errors.patientAddress.message : ""}</FormHelperText> 
 
                                        )}
                                    </>                               
                                    )}
                                
                                rules={{
                                    validate: (value) => {
                                        if (value == '') {
                                            return "Patient Address is required"
                                        }
                                    }
                                }}
                                                     
                            />                         
                        </Grid>

<Grid item xs={12} sm={6}>
    <div className={classes.formControlLabel}>
     PATIENT MOBILE PHONE
    </div>
    <Controller
        control={control}
        render={({ onChange, onBlur, value, name }) => (
            <React.Fragment>
                <TextField
                    onChange={e => {
                        onChange(e);
                    }}
                    onBlur={e => {
                        handleindexdbsave('PatientMobilePhone', e.target.value);
                        setPatientMobilePhoneIdb(e.target.value);
                    }}
                    value={value}
                    autoComplete='off'
                    name={name}
                   // error={Boolean(errors.PatientMobilePhone)}
                   // helperText={errors.PatientMobilePhone ? errors.PatientMobilePhone.message : ""}
                    InputProps={{ classes: { root: classes.textFieldInput } }}
                    inputProps={{ maxLength: 15, minLength: 0,autocomplete: 'disabled'}}
                    variant="outlined"
                />
                {errors.PatientMobilePhone && (
                   <FormHelperText style={{color:"red"}}>{errors.PatientMobilePhone ? errors.PatientMobilePhone.message : ""}</FormHelperText> 
                )}
            </React.Fragment>
        )}
        name="PatientMobilePhone"
        rules={{
            validate: value => {               
                if (value && !/^[\+]?[0-9\s]{5,20}$/.test(value)) {
                    return "Invalid Patient Mobile Phone Number";
                } else if (value == "" || value == null  || value == undefined) {
                  var Kinmobile = getValues("KinMobilePhone");
                  var Patmobile = getValues("PatientMobilePhone");
                  if (pcr.ValidateAllFields) {
                    if (
                        (Kinmobile == "" && Patmobile == "") ||
                        (Kinmobile == undefined && Patmobile == undefined)
                      ) {
                        return "Either a patient or next-of-kin mobile number is required";
                      }
                      //return "Patient Mobile Phone is required";
                  }
                }
            },
            // pattern: {
            //     value: /^[\+]?[0-9\s]{5,20}$/,
            //     message: "Invalid Patient Mobile Phone Number",
            // },
            
        }}
    />

                    <Controller
                        control={control}
                        name="patient_not_survey"
                        defaultValue={false}
                        render={({ onChange, onBlur, value, name }) => (
                            <>
                                <FormControl fullWidth error={Boolean(errors.patient_not_survey)}>
                                    <FormControlLabel
                                        control={<Checkbox className={classes.checkboxInput} />}
                                        label='Patient does not consent to survey'
                                        checked={value}
                                        onChange={(e: React.ChangeEvent<any>) =>
                                            onChange(e.target.checked,
                                                handleindexdbsave('survey', e.target.checked),
                                                setsurveyIdb(e.target.checked))
                                        }
                                        onBlur={(e) => {
                                            handleindexdbsave('survey', value);
                                            setsurveyIdb(value);
                                        }}
                                        style={{ marginTop: 15 }}
                                    />
                                </FormControl>
                                {errors.patient_not_survey && (
                                    <FormHelperText>
                                        {errors.patient_not_survey.message}
                                    </FormHelperText>
                                )}
                            </>
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                        NEXT OF KIN MOBILE PHONE
                    </div>
                    <Controller
                        control={control}
                        render={({ onChange, onBlur, value, name }) => (
                            <React.Fragment>
                                <TextField
                                    onChange={e => {
                                        onChange(e);
                                    }}
                                    onBlur={e => {
                                        handleindexdbsave('KinMobilePhone', e.target.value);
                                        setKinMobilePhoneIdb(e.target.value);
                                    }}
                                    value={value}
                                    name={name}
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    inputProps={{ maxLength: 15, minLength: 0, autocomplete: 'disabled' }}
                                    variant="outlined"
                                />
                                {errors.KinMobilePhone && (
                                    <FormHelperText style={{ color: "red" }}>{errors.KinMobilePhone ? errors.KinMobilePhone.message : ""}</FormHelperText>
                                )}
                            </React.Fragment>
                        )}
                        name="KinMobilePhone"
                        rules={{
                            validate: value => {
                                if (value !== null && value !== " " && value !== "" && value !== undefined) {
                                    if (!/^[\+]?[0-9\s]{5,20}$/.test(value)) {
                                        return "Invalid Next-Of-Kin Mobile Phone Number";
                                    }

                                }
                            },
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        {pcr.ValidateAllFields && <Icons.RequiredIcon />}Either a patient or next-of-kin mobile number is required
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                        {/* <Icons.RequiredIcon />  */}
                        NEXT OF KIN NAME
                    </div>
                    <Controller
                        control={control}
                        render={({ onChange, onBlur, value, name }) => (
                            <React.Fragment>
                                <TextField
                                    onChange={e => {
                                        onChange(e)
                                    }}
                                    onBlur={(e) => {
                                        handleindexdbsave('KinName', e.target.value);
                                        setKinNameIdb(e.target.value);
                                    }}
                                    value={value}
                                    name={name}
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    inputProps={{ maxLength: 100, minLength: 0, autocomplete: 'disabled' }}
                                    required
                                    variant="outlined">

                                </TextField>

                                <FormHelperText style={{ color: "red" }}>{errors.KinName ? errors.KinName.message : ""}</FormHelperText>

                            </React.Fragment>
                        )}
                        name="KinName"
                        rules={{
                        }}
                    />
                </Grid>
                {(pcrType === "2"|| pcrType === "3") && (<>
                <Grid item xs={12} sm={6}>
                    <div className={classes.formControlLabel}>
                    { pcr.ValidateAllFields &&<Icons.RequiredIcon /> } PATIENT TRANSPORT BOOKING NUMBER
                    </div>
                    <Controller
                        control={control}
                        render={({ onChange, onBlur, value, name }) => (
                            <React.Fragment>
                                <TextField
                                onChange={(e: any) => { onChange(e);  
                                    setPatientTranBookNoIdb(e.target.value);
                                    handleindexdbsave('PatientTranBookNo', e.target.value);}}
                                    // onChange={e => {
                                    //     onChange(e), setPatientTranBookNoIdb(e.target.value)
                                    // }}
                                    onBlur={(e) => {
                                        handleindexdbsave('PatientTranBookNo', e.target.value);
                                        setPatientTranBookNoIdb(e.target.value);
                                    }}
                                    value={PatientTranBookNoIdb}
                                    name={name}
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    inputProps={{ maxLength: 100, minLength: 0,autocomplete:'disabled' }}
                                  //  required                               
                                    error={errors.PatientTransportBookingNumber} helperText={errors.PatientTransportBookingNumber  ? errors.PatientTransportBookingNumber.message : ""}
                                    variant="outlined">

                                    </TextField>
                                </React.Fragment>
                            )}
                            name="PatientTransportBookingNumber"
                            rules={{
                                validate: validateBooking
                            }}
                        />
                    </Grid></>)}
                {pcrType !== "1" && <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        { pcr.ValidateAllFields && <Icons.RequiredIcon /> } REASON FOR TRANSPORT
                    </div>
                    <Controller
                        control={control}
                        name="ReasonForTransport"
                        defaultValue={ReasonForTransport}
                        render={({ onChange, onBlur, value, name }) => (
                            <React.Fragment>
                                <TextField
                                    onChange={e => {
                                        onChange(e)
                                    }}
                                    onBlur={(e) => {
                                        handleindexdbsave('ReasonForTransport', e.target.value);
                                        setReasonForTransport(e.target.value);
                                    }}
                                    value={value}
                                    name={name}
                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                    inputProps={{ autocomplete: 'disabled' }}
                                    required
                                    variant="outlined"
                                />
                                <FormHelperText style={{ color: "red" }}>{errors.ReasonForTransport ? errors.ReasonForTransport.message : ""}</FormHelperText>
                            </React.Fragment>
                        )}
                        rules={{
                            required: {value:pcr.ValidateAllFields,message:"This field is required"},
                        }}
                    />
                </Grid>}
                <Grid item xs={12} sm={12}>
                    <div style={{ borderBottom: '2px solid #F1F1F1', margin: '8px 0px 0px 0px' }}></div>
                </Grid>
                
            </Grid >
        </div >
    );
}

export default React.memo(withRouter(SubFormWidget));

